import styled from 'styled-components';
import { FlexibleButtonModel } from '@services/flexible_component/mod';
import { Routeable } from './_flexible_identifier_routeable.component';
import { Text } from '@visiba-cortex/react-ui-std';
import { FONT_VARIANT } from '../../constants';
import { theme } from '@services/theme.service/theme';
import { rem } from '@visiba/std';

interface Props {
	component: FlexibleButtonModel;
	__TEMP__overrideNavigation?: (url: string) => void;
	__TEMP__on_OPW_WebContentButton_proxy_invoke?: (flexibleIdentifierData: {
		url: string;
		openUrlWith: string;
		requiresAuthentication: boolean;
	}) => void;
}

const elements = {
	button: styled.div`
		display: flex;
		align-items: center;
		width: 100%;
		background: ${theme.primary};
		border-radius: ${rem(10)};
		height: ${rem(64)};
		padding: 0 ${rem(16)} 0 ${rem(20)};
		color: #fff;
	`,
};

export function FlexibleButton({ component, __TEMP__on_OPW_WebContentButton_proxy_invoke }: Props): JSX.Element {
	return (
		<Routeable
			url={component.url}
			requiresAuthentication={component.requiresAuthentication}
			openWith={component.openUrlWith}
			__TEMP__on_OPW_WebContentButton_proxy_invoke={__TEMP__on_OPW_WebContentButton_proxy_invoke}
		>
			<elements.button data-testid='FlexibleButton'>
				<Text font={FONT_VARIANT.LARGE_BODY}>{component.title}</Text>
			</elements.button>
		</Routeable>
	);
}
